import {UrlStateManagerService} from 'shared/state-manager';
import register from '@kpsys/angularjs-register';

export default register('portaro.shared.state-manager')
    .service(UrlStateManagerService.serviceName, UrlStateManagerService)
    .name()
